import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
    versionIndex: number;
}

export default function TrackingTable(props: Props) {
    const colorGray = 'rgba(140,140,140,1)';
    const colorWhite = 'rgba(255,255,255,1)';
    const colorYellow = 'rgba(255,255,140,1)';
    const colorRed = 'rgba(255,140,140,1)';
    const [colorStr, setColorStr] = useState<string[]>([]);
    const [chlStr, setCHLStr] = useState<string[]>([]);
    const [prnStr, setPRNStr] = useState<string[]>([]);
    const [stateStr, setStateStr] = useState<string[]>([]);
    const [sourceStr, setSourceStr] = useState<string[]>([]);
    const [fpgaStr, setFPGAStr] = useState<string[]>([]);
    const [azMeasuredStr, setAzMeasuredStr] = useState<string[]>([]);
    const [elMeasuredStr, setElMeasuredStr] = useState<string[]>([]);
    const [locktimeStr, setLockTimeStr] = useState<string[]>([]);
    const [snrStr, setSNRStr] = useState<string[]>([]);
    
    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            let sColor: Array<string> = [];
            let sCHL: Array<string> = [];
            let sPRN: Array<string> = [];
            let sState: Array<string> = [];
            let sSource: Array<string> = [];
            let sFPGA: Array<string> = [];
            let sAzMeasured: Array<string> = [];
            let sElMeasured: Array<string> = [];
            let sLockTime: Array<string> = [];
            let sSNR: Array<string> = [];
            for(let i = 0; i < SNStatus[props.index].Tracking.PRN.length; ++i) {
                sCHL.push(i.toString());
                if(SNStatus[props.index].Tracking.Status[i] === 'RESERVED') {
                    sState.push('RESERVED');
                } else if(SNStatus[props.index].Tracking.Status[i] === 'ALLOCATED') {
                    sState.push('ALLOCATED');
                } else if(SNStatus[props.index].Tracking.Status[i] === 'ACQUIRED') {
                    sState.push('ACQUIRED');
                } else {
                    sState.push('IDLE');
                }
                if(SNStatus[props.index].Tracking.FPGA[i] === 'LOCKED') {
                    sFPGA.push('LOCKED');
                    if(SNStatus[props.index].Tracking.Source[i] === 'UNKNOWN') {
                        sColor.push(colorGray);
                    } else if(SNStatus[props.index].Tracking.Source[i] === 'SPOOFER') {
                        sColor.push(colorRed);
                    } else {
                        if(SNStatus[props.index].Tracking.Band[i] === 'L1') {
                            sColor.push(colorWhite);
                        } else {
                            sColor.push(colorYellow);
                        }
                    }
                    if((SNStatus[props.index].Tracking.Azimuth[i] != null) &&
                       (SNStatus[props.index].Tracking.Elevation[i] != null) &&
                       (SNStatus[props.index].Tracking.LockTime[i] != null) &&
                       (SNStatus[props.index].Tracking.SNR[i] != null)) {
                        sAzMeasured.push((SNStatus[props.index].Tracking.Azimuth[i] * 180.0 / Math.PI).toFixed(2));
                        sElMeasured.push((SNStatus[props.index].Tracking.Elevation[i] * 180.0 / Math.PI).toFixed(2));
                        sLockTime.push(SNStatus[props.index].Tracking.LockTime[i].toFixed(1));
                        sSNR.push(SNStatus[props.index].Tracking.SNR[i].toFixed(1));
                    } else {
                        sAzMeasured.push('---');
                        sElMeasured.push('---');
                        sLockTime.push('---');
                        sSNR.push('---');
                    }
                } else {
                    if(SNStatus[props.index].Tracking.FPGA[i] === 'REACQUIRE') {
                        sFPGA.push('REACQUIRE');
                    } else {
                        sFPGA.push('NOTLOCKED');
                    }
                    sColor.push(colorGray);
                    sAzMeasured.push('---');
                    sElMeasured.push('---');
                    sLockTime.push('---');
                    sSNR.push('---');
                }
                if(SNStatus[props.index].Tracking.PRN[i] < 0) {
                    sPRN.push('---');
                } else {
                    sPRN.push(SNStatus[props.index].Tracking.PRN[i].toString());
                }
                if(SNStatus[props.index].Tracking.Source[i] === 'UNKNOWN') {
                    sSource.push('UNKNOWN');
                } else if(SNStatus[props.index].Tracking.Source[i] === 'SPOOFER') {
                    sSource.push('SPOOFER');
                } else {
                    sSource.push('GPS');
                }
            }
            setColorStr(sColor);
            setCHLStr(sCHL);
            setPRNStr(sPRN);
            setStateStr(sState);
            setSourceStr(sSource);
            setFPGAStr(sFPGA);
            setAzMeasuredStr(sAzMeasured);
            setElMeasuredStr(sElMeasured);
            setLockTimeStr(sLockTime);
            setSNRStr(sSNR);
        } else {
            let sColor: Array<string> = [];
            let sCHL: Array<string> = [];
            let sPRN: Array<string> = [];
            let sState: Array<string> = [];
            let sSource: Array<string> = [];
            let sFPGA: Array<string> = [];
            let sAzMeasured: Array<string> = [];
            let sElMeasured: Array<string> = [];
            let sLockTime: Array<string> = [];
            let sSNR: Array<string> = [];
            setColorStr(sColor);
            setCHLStr(sCHL);
            setPRNStr(sPRN);
            setStateStr(sState);
            setSourceStr(sSource);
            setFPGAStr(sFPGA);
            setAzMeasuredStr(sAzMeasured);
            setElMeasuredStr(sElMeasured);
            setLockTimeStr(sLockTime);
            setSNRStr(sSNR);
        } 
    }, [SNTime, props.index]);
    
    function V0() {
        return (
        <div>
            <Table><TableBody>
                <TableRow style={{height:'7px'}}>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>CHL</TableCell>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>PRN</TableCell>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>State</TableCell>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>Source</TableCell>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>FPGA Status</TableCell>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>Az Measured</TableCell>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>El Measured</TableCell>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>Lock Time</TableCell>
                    <TableCell  style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>SNR</TableCell>
                </TableRow>
                {prnStr && prnStr.map((prn, index) => (
                    <TableRow style={{height:'7px'}}>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{chlStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{prnStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{stateStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{sourceStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{fpgaStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{azMeasuredStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{elMeasuredStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{locktimeStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{snrStr[index]}</TableCell>
                    </TableRow>
                ))}
            </TableBody></Table>
        </div>
	)
    }
    
    function V1() {
        return (
        <div>
            <Table><TableBody>
                <TableRow style={{height:'7px'}}>
                    <TableCell  style={{width:'80px', paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>CHL</TableCell>
                    <TableCell  style={{width:'80px', paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>PRN</TableCell>
                    <TableCell  style={{width:'200px', paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>State</TableCell>
                    <TableCell  style={{width:'200px', paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>Source</TableCell>
                    <TableCell  style={{width:'100px', paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>SNR</TableCell>
                </TableRow>
                {prnStr && prnStr.map((prn, index) => (
                    <TableRow style={{height:'7px'}}>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{chlStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{prnStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{stateStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{sourceStr[index]}</TableCell>
                        <TableCell style={{paddingTop: 2, paddingBottom: 0, color: colorStr[index], fontSize:'12px'}}>{snrStr[index]}</TableCell>
                    </TableRow>
                ))}
            </TableBody></Table>
        </div>
	)
    }
    
    if(props.versionIndex === 1) {
        return (V1())
    } else {
        return (V0())
    }
}
